import axios from "axios"
import qs from 'qs'
import merge from 'lodash/merge'
import {logout} from "@/utils/login"
import Vue from 'vue'

const http = axios.create({
    timeout: 1000 * 30,
    withCredentials: true,
    baseURL: process.env.NODE_ENV !== 'production' && process.env.OPEN_PROXY ? '/api' : process.env.VUE_APP_proxybaseurl + '/api',
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X_PROXY_GATEWAY':true,
        'Content-Type': 'application/json; charset=utf-8',
        "Cache-Control": 'no-cache',
        ['Pragma']: 'no-cache'
    }
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
    config.headers['access_token'] = Vue.cookie.get('access_token') || Vue.cookie.get('oauth_access_token') || localStorage.getItem('oauth_access_token')// 请求头带上token
    return config
}, error => {
    return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(response => {
    if (response.data && (response.data.code === 401 || response.data.code === '1003')) { // 401, token失效 1003 登录失效
        logout(false)
    } else  if (response.data && (response.data.code === '1006')) {
        alert('你的账号已在别处登录!')
        logout(false)
    }else if(response.data && (response.data.code === '9999' )){
        return Promise.reject(response.data.msg)
    }
    return response
}, error => {
    return Promise.reject(error)
})

/**
 * 请求地址处理，倍抛弃方法，ajax使用统计基础地质
 * @param {*} actionName action方法名称
 */
http.adornUrl = (actionName) => {
    return (process.env.NODE_ENV !== 'production' && process.env.OPEN_PROXY ? '' : process.env.VUE_APP_proxybaseurl) + actionName
}

/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefultParams 是否开启默认参数?
 */
http.adornParams = (params = {}, openDefultParams = true) => {
    var defaults = {
        't': new Date().getTime()
    }
    return openDefultParams ? merge(defaults, params) : params
}

/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefultdata 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
http.adornData = (data = {}, openDefultdata = true, contentType = 'json') => {
    var defaults = {
        't': new Date().getTime()
    }
    data = openDefultdata ? merge(defaults, data) : data
    return contentType === 'json' ? JSON.stringify(data) : qs.stringify(data)
}

export default http